module.exports = __webpack_public_path__ + "media/customizations/newfield/logo-new-8cb6d57ece2e73591fdad95645329d61.png";